/** `FormTimeSelectField`'in saf yardımcıları (Fast Refresh için bileşen dosyasından ayrı). */

/** 24 saat biçimi "HH:mm" (00:00–23:59) — `FormTimeField` ile aynı. */
const TIME_RE = /^([01]\d|2[0-3]):[0-5]\d$/

const pad2 = (n: number) => String(n).padStart(2, '0')

/** Açılır listenin seçenekleri: 30 dakikalık adımlar, 00:00 … 23:30 (48 satır). */
export const HALF_HOUR_SLOTS: readonly string[] = Array.from(
  { length: 48 },
  (_, i) => `${pad2(Math.floor(i / 2))}:${i % 2 === 0 ? '00' : '30'}`,
)

/** Elle yazılan kısa biçimler: "9" · "09" · "9:30" · "9.30" · "0930". */
const SHORT_FORMS = [/^(\d{1,2})$/, /^(\d{1,2})[:.](\d{2})$/, /^(\d{2})(\d{2})$/]

/**
 * Elle yazılan saati "HH:mm"e tamamlar ("9" → "09:00", "9.30" → "09:30"). Tanınmayan ya da aralık
 * dışı girdi olduğu gibi döner — hatayı şema gösterir.
 */
export function normalizeTime(raw: string): string {
  const value = raw.trim()
  for (const re of SHORT_FORMS) {
    const m = re.exec(value)
    if (!m) continue
    const candidate = `${pad2(Number(m[1]))}:${m[2] ?? '00'}`
    return TIME_RE.test(candidate) ? candidate : value
  }
  return value
}

/** Yazılan öneki taşıyan seçenekler ("8" → 08:00, 08:30); boş sorgu → tüm liste (açılır düğme). */
export function matchSlots(query: string): string[] {
  const q = query.trim().replace('.', ':')
  if (!q) return [...HALF_HOUR_SLOTS]
  return HALF_HOUR_SLOTS.filter((s) => s.startsWith(q) || s.startsWith(`0${q}`))
}
